(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["curiohue-nav"]) return;
  try {
    

(function(){
  const nav = document.querySelector('[data-curiohue-nav]');
  const toggle = document.querySelector('[data-curiohue-menu-toggle]');
  if (nav && toggle) {
    toggle.addEventListener('click', function(){
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }
  document.querySelectorAll('[data-ch-scroll]').forEach(function(link){
    link.addEventListener('click', function(evt){
      const href = link.getAttribute('href') || '';
      if (href.startsWith('#')) {
        const el = document.querySelector(href);
        if (el) { evt.preventDefault(); el.scrollIntoView({behavior:'smooth', block:'start'}); }
      }
    });
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["curiohue-pdp-cro"] && !Shopify.designMode) return;
  try {
    
(function(){
  function initPdp(root) {
    const mapEl = root.querySelector('[data-ch-variant-map]');
    const optionsEl = root.querySelector('[data-ch-option-names]');
    const select = root.querySelector('[data-ch-variant-select]');
    if (!mapEl || !select) return;
    let variantMap = {};
    let optionNames = [];
    try { variantMap = JSON.parse(mapEl.textContent || '{}'); } catch(e) { variantMap = {}; }
    try { optionNames = JSON.parse((optionsEl && optionsEl.textContent) || '[]'); } catch(e) { optionNames = []; }
    const variants = Object.keys(variantMap).map(function(id){ return variantMap[id]; });
    const colorIndex = Math.max(0, optionNames.findIndex(function(name){ return String(name || '').toLowerCase().indexOf('color') !== -1; }));
    const swatchWrap = root.querySelector('[data-ch-color-swatches]');
    const heroImg = root.querySelector('[data-ch-hero-img]');
    const fallbackHeroSrc = heroImg ? heroImg.getAttribute('src') : '';
    const fallbackHeroAlt = heroImg ? heroImg.getAttribute('alt') : '';

    function setText(selector, value) { root.querySelectorAll(selector).forEach(function(el){ el.textContent = value || ''; }); }
    function applyVariant(id) {
      const data = variantMap[id] || variants[0];
      if (!data) return;
      root.style.setProperty('--ch-selected', data.hex || '#d96f8a');
      root.style.setProperty('--ch-selected-soft', data.soft_hex || '#fff3ec');
      root.style.setProperty('--ch-selected-accent', data.accent_hex || '#b84f6b');
      root.style.setProperty('--ch-selected-contrast', data.contrast_hex || '#33272a');
      root.querySelectorAll('[data-ch-color-chip]').forEach(function(el){ el.style.background = data.hex || '#d96f8a'; });
      if (heroImg) {
        const nextSrc = data.featured_media_src || fallbackHeroSrc;
        if (nextSrc && heroImg.getAttribute('src') !== nextSrc) heroImg.setAttribute('src', nextSrc);
        heroImg.setAttribute('alt', data.featured_media_alt || fallbackHeroAlt || data.color_name || 'Selected variant image');
      }
      setText('[data-ch-color-name]', data.color_name || 'selected color');
      setText('[data-ch-vibe-headline]', data.vibe_headline || 'Styled in your selected color');
      setText('[data-ch-vibe-copy]', data.vibe_copy || 'The page palette updates to match this variant.');
      setText('[data-ch-room-prompt]', data.room_prompt || 'Pick the shade that matches your space.');
      root.querySelectorAll('.ch-pdp-swatch-button').forEach(function(btn){ btn.classList.toggle('is-active', btn.getAttribute('data-color-name') === String(data.color_name || '')); });
    }
    function renderSwatches() {
      if (!swatchWrap || !variants.length) return;
      const seen = new Set();
      swatchWrap.innerHTML = '';
      variants.forEach(function(v){
        const name = String(v.color_name || 'Color');
        if (seen.has(name)) return;
        seen.add(name);
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'ch-pdp-swatch-button';
        btn.setAttribute('aria-label', 'Choose ' + name);
        btn.setAttribute('title', name);
        btn.setAttribute('data-color-name', name);
        btn.style.background = v.hex || '#ffd1dc';
        btn.addEventListener('click', function(){
          const current = variantMap[select.value] || variants[0];
          const match = variants.find(function(candidate){
            if (String(candidate.color_name || '') !== name) return false;
            if (!current || !current.options || !candidate.options) return true;
            return candidate.options.every(function(opt, idx){ return idx === colorIndex || String(opt || '') === String(current.options[idx] || ''); });
          }) || variants.find(function(candidate){ return String(candidate.color_name || '') === name; });
          if (match) { select.value = String(match.id); select.dispatchEvent(new Event('change', { bubbles:true })); }
        });
        swatchWrap.appendChild(btn);
      });
    }
    renderSwatches();
    select.addEventListener('change', function(){ applyVariant(select.value); });
    applyVariant(select.value);
  }
  document.querySelectorAll('[data-ch-pdp]').forEach(initPdp);
})();

  } catch(e) { console.error(e); }
})();
})();
